"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ReturnIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.002 4.003a1 1 0 011.656-.756l4.487 3.9a1 1 0 01-.013 1.521l-4.48 3.76a1 1 0 01-1.644-.764l-.006-7.661zM4 4.8a1 1 0 10-2 0v.382A3.618 3.618 0 005.618 8.8H8v-2H5.618A1.618 1.618 0 014 5.182V4.8z"
  })))
});
ReturnIcon.displayName = 'ReturnIcon';
var _default = exports.default = ReturnIcon;